import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=c1e0104a&"
import script from "./FormPage.vue?vue&type=script&lang=ts&"
export * from "./FormPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1e0104a')) {
      api.createRecord('c1e0104a', component.options)
    } else {
      api.reload('c1e0104a', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=c1e0104a&", function () {
      api.rerender('c1e0104a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/work-order/FormPage.vue"
export default component.exports